import { Button, Card, Col, Drawer, Form, notification, Row } from 'antd'
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { formItemLayout } from '../../../components/_utils/appUtils'
import { addConferenceNote, getConferenceNotes } from '../actions'

@Form.create()
class AddNoteForConferenceInterest extends React.Component {
    state = {
        noteData: []
    }

    handleSubmit = e => {
        const {
            dispatch,
            form,
            conferenceInterestId
        } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                // Mapping to articleId as it's the expected key for the 'allNotes' collection
                valData.articleId = conferenceInterestId
                valData.time = moment().format('lll')
                // Specifically adding schema information to keep conference notes separate
                valData.schemaType = 'conferenceEvent notes' 

                let resp = await dispatch(addConferenceNote(valData))

                if (resp && resp.success) {
                    notification.success({
                        message: resp.message || 'Note added successfully'
                    })
                    form.resetFields()
                    this.loadNotes()
                } else {
                    notification.error({
                        message: resp.message || 'Error adding note'
                    })
                }
            } else {
                notification.error({
                    message: 'Please enter all required fields.'
                })
            }
        })
    }

    loadNotes = () => {
        return new Promise(async resolve => {
            let { dispatch, conferenceInterestId } = this.props
            let obj = {
                articleId: conferenceInterestId,
                schemaType: 'conferenceEvent notes'
            }
            let data = await dispatch(getConferenceNotes(obj))
            if (data && !data.error) {
                let notes = Array.isArray(data) ? data : (data.data || [])
                // Robust sort by time (latest first)
                notes = [...notes].sort((a, b) => {
                    return moment(b.createdAt || b.time).unix() - moment(a.createdAt || a.time).unix()
                })
                this.setState({ noteData: notes })
                resolve(notes)
            } else {
                resolve([])
            }
        })
    }

    componentDidMount() {
        this.loadNotes()
    }

    render() {
        const { noteData } = this.state
        const {
            form: { getFieldDecorator },
            visible,
            onClose
        } = this.props

        let inputSchema = [
            {
                label: 'Add Note',
                key: 'note',
                required: true,
                type: 'textArea',
                placeholder: 'Add Note'
            }
        ]

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                width={'50%'}
                title={'Conference Event Notes'}>
                <Card bordered={false}>
                    <Form
                        onSubmit={this.handleSubmit}
                        hideRequiredMark
                        className={'inputForm'}>
                        <Row gutter={16}>
                            {inputSchema.map((item, key) => {
                                return (
                                    <Col span={24} key={key}>
                                        <GetEachFormFields
                                            item={item}
                                            getFieldDecorator={getFieldDecorator}
                                            formItemLayout={formItemLayout}
                                        />
                                    </Col>
                                )
                            })}
                            <Col span={24}>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <div style={{ marginTop: '20px' }}>
                                    <h3>History</h3>
                                    {noteData && noteData.length > 0 ? (
                                        noteData.map((item, i) => (
                                            <Card
                                                key={i}
                                                bordered={true}
                                                style={{ marginBottom: '10px' }}
                                                title={item.addedBy || 'Admin'}
                                                extra={moment(item.time).format('DD.MM.YYYY, h:mm A')}>
                                                {item.note}
                                            </Card>
                                        ))
                                    ) : (
                                        <p>No previous notes available.</p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(null, mapDispatchToProps)(AddNoteForConferenceInterest)
